import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ContentViewer } from "./contentStateSlicedata.ts";

interface Payload {
  contentId: string;
  progress?: string;
  progressPercentage?: number;
  learnerCount?: number;
  data?: ContentViewer;
  enableCompletion?: boolean;
}

interface ContentItemState {
  progress?: string;
  progressPercentage?: number;
  learnerCount?: number;
  data?: ContentViewer;
  enableCompletion?: boolean;
}

const INIT_STATE: Record<string, ContentItemState> = {};

const ContentStateSlice = createSlice({
  name: "ContentStateSlice",
  initialState: INIT_STATE,
  reducers: {
    setData(state, action: PayloadAction<Payload>) {
      const { contentId, data } = action.payload;
      state[contentId] = { ...state[contentId], data };
    },
    setProgress(state, action: PayloadAction<Payload>) {
      const { contentId, progress, progressPercentage } = action.payload;
      state[contentId] = { ...state[contentId], progress, progressPercentage };
    },
    setLearnerCount(state, action: PayloadAction<Payload>) {
      const { contentId, learnerCount } = action.payload;

      state[contentId] = { ...state[contentId], learnerCount };
    },
    setCompletionStatus(state, action: PayloadAction<Payload>) {
      const { contentId, enableCompletion } = action.payload;
      state[contentId] = { ...state[contentId], enableCompletion };
    }
  }
});

export default ContentStateSlice;

export const ContentStateSliceActions = ContentStateSlice.actions;
